import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MultiSelectDropDown from '../../../form-components/MultiSelectDropDownComponent'
import CustomDatePicker from '../../../common/CustomDatePicker'
import { statusList, SuccessfulMessage } from '../mastersConfigConstants'
import { useDispatch, useSelector } from 'react-redux'
import { focusElemnt, formatDate, navigation3 } from '../../../../utilityFunctions'
import { LinkPlaceInsertUpdate } from '../../../../redux/KSRTC_Redux/MasterConfig/MasterAction'
import Alert from '../../../common/Alert'
import SuccessfulModal from '../../../common/successfulModal'

const LinkPlaceConfigFilters = (props) => {
  const userState = useSelector((store) => store.user);
  const { isEdit = false, isView = false, data = {}, handleBack, getTableData } = props
  const dispatch = useDispatch()
  const { placeList } = useSelector((store) => store.masterConfig);
  const [linkPlaceData, setLinkPlaceData] = useState({
    startPlace: [], linkPlace: [], endPlace: [], status: [statusList[1]],
    fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
    toDate: formatDate(window.getTime ? window.getTime() : new Date())
  })
  const [filterOpt, setFilterOpt] = useState({
    startPlace: placeList, endPlace: placeList, linkPlace: placeList
  })
  const [showAlert, setShowAlert] = useState({
    msg: '',
    open: false
  });
  const [msg, setmsg] = useState("")
  const [successModal, setSuccessModal] = useState(false)
  useEffect(() => {
    focusElemnt('lvfCorpCode')
  }, [])
  useEffect(() => {
    if (isEdit || isView) {
      let filterStartPlace = placeList?.filter((val) => val.CityID === data?.FromCityID)
      let filterEndPlace = placeList?.filter((val) => val.CityID === data?.ToCityID)
      let filterLinkPlace = placeList?.filter((val) => val.CityID === data?.LinkCityID)
      setLinkPlaceData((prev) => ({
        ...prev,
        startPlace: filterStartPlace,
        endPlace: filterEndPlace,
        linkPlace: filterLinkPlace,
        fromDate: data?.StartDT,
        toDate: data?.EndDT,
        status: data?.IsActive === 1 ? [statusList[1]] : [statusList[0]]
      }))
    }
  }, [])
  const statusProps = () => {
    return {
      id: 'levyStatus',
      width: "100%",
      name: "levyStatus",
      isCompulsory: false,
      options: statusList || [],
      preSelectedValues: linkPlaceData?.status || [],
      searchPlaceholder: "Search by Status",
      isObject: true,
      primaryKey: 'id',
      labelKey: 'name',
      singleSelect: true,
      selectAllOption: false,
      disabled: isView,
      prevId: 'levyMaxBaseFare',
      nextId: 'leviesFor'
    }
  }
  const handleReset = () => {
    if (isEdit) {
      // setLeviesData(data)
      // const corpoData = corporationList?.filter((val) => val.CorporationID === data?.CorporationID)
      // const leavyData = leviesFilterList?.filter((val) => val.LevyID === data?.LevyID)
      // const isPerData = lumpSumList?.filter((val) => val.id === data?.IsPercentage)
      // const isRefundData = yesNoList?.filter((val) => val.id === data?.IsRefundable)
      // const isActiveData = statusList?.filter((val) => val.id === data?.IsActive)
      // const LevyTypeIDData = leviesForList?.filter((val) => val.id === data?.LevyTypeID)
      // setLeviesData((prev) => ({ ...data, CorporationCode: corpoData, LevyName: leavyData, IsPercentage: isPerData, IsRefundable: isRefundData, IsActive: isActiveData, LevyTypeID: LevyTypeIDData }))
    }
    else {
      setLinkPlaceData({
        startPlace: [],
        linkPlace: [],
        endPlace: [],
        status: [],
        fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
        toDate: formatDate(window.getTime ? window.getTime() : new Date())
      })
    }
  }
  const handleSave = () => {
    if (linkPlaceData?.startPlace?.length === 0) {
      handleSetAlert('Please Select Start Place');
    } else if (linkPlaceData?.linkPlace?.length === 0) {
      handleSetAlert('Please Select Link Place');
    } else if (linkPlaceData?.endPlace?.length === 0) {
      handleSetAlert('Please Select End Place');
    } else {
      let obj = {
        UserID: userState?.UserID,
        CompanyID: userState?.CompanyID,
        LinkID: isEdit ? data?.LinkID : 0,
        FromCityID: linkPlaceData?.startPlace[0]?.CityID,
        LinkCityID: linkPlaceData?.linkPlace[0]?.CityID,
        ToCityID: linkPlaceData?.endPlace[0]?.CityID,
        StartDT: linkPlaceData?.fromDate,
        EndDT: linkPlaceData?.toDate,
        IsActive: linkPlaceData?.status[0]?.id,
      }
      dispatch(LinkPlaceInsertUpdate(obj)).then((res) => {
        if (res?.data?.status) {
          if (isEdit) {
            handleSetAlert('Link Place Configuration Updated Successfully!');
          } else {
            handleSetAlert('Link Place Configured Successfully!');
          }
          getTableData()
        } else {
          handleSetAlert(res?.data?.Message);
        }
      })
    }

  }
  const handleSetAlert = (msg) => {
    setShowAlert((prev) => ({
      ...prev,
      msg: msg,
      open: true
    }))
  }

  const handleAlertClose = () => {
    setShowAlert((prev) => ({
      ...prev,
      msg: '',
      open: false
    }))
  }
  const startPlaceProps = () => {
    return {
      id: 'startPlace',
      width: "100%",
      name: "startPlace",
      label: "Start Place",
      isCompulsory: false,
      options: filterOpt?.startPlace,
      optionLimit: 50,
      preSelectedValues: linkPlaceData?.startPlace || [],
      searchPlaceholder: "Search by start Place",
      disabled: isView,
      isObject: true,
      primaryKey: 'CityID',
      labelKey: 'ActualCityName',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: false,
      defaultAllSelected: false,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  const endPlaceProps = () => {
    // let filterList = linkPlaceData?.startPlace?.length > 0 ? placeList.filter((city) => city.CityID !== linkPlaceData?.startPlace?.[0]?.CityID) : placeList
    return {
      id: 'endPlace',
      width: "100%",
      name: "endPlace",
      label: "End Place",
      isCompulsory: false,
      options: filterOpt?.endPlace,
      optionLimit: 50,
      preSelectedValues: linkPlaceData?.endPlace || [],
      searchPlaceholder: "Search by Place Name",
      disabled: isView,
      isObject: true,
      primaryKey: 'CityID',
      labelKey: 'ActualCityName',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: false,
      defaultAllSelected: false,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  const linkPlaceProps = () => {
    //  let filterList = linkPlaceData?.startPlace?.length > 0 ? placeList.filter((city) => city.CityID !== linkPlaceData?.startPlace?.[0]?.CityID) : placeList
    return {
      id: 'linkPlace',
      width: "100%",
      name: "linkPlace",
      label: "Link Place",
      isCompulsory: false,
      options: filterOpt?.linkPlace,
      optionLimit: 50,
      preSelectedValues: linkPlaceData?.linkPlace || [],
      searchPlaceholder: "Search by Place Name",
      disabled: isView,
      isObject: true,
      primaryKey: 'CityID',
      labelKey: 'ActualCityName',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: false,
      defaultAllSelected: false,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  return (
    <>
      <Grid
        container
        spacing={0}
        className="column-container"
        style={{
          padding: "16px 16px 48px 16px",
        }}
      >
        <Grid item md={6}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}
        >
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px'
            }}
          >
            <Grid item md={4}> Start Place <span style={{ color: '#E72A01' }}>*</span></Grid>
            <Grid item md={8}>
              <MultiSelectDropDown
                {...startPlaceProps()}
                onSelect={(val) => {
                  setLinkPlaceData(prev => ({ ...prev, startPlace: val }));
                  let filterListLink = placeList?.filter((city) => city.CityID !== val[0]?.CityID)
                  let filterListEnd = placeList?.filter((city) => city.CityID !== val[0]?.CityID)
                  setFilterOpt((prev) => ({ ...prev, endPlace: filterListEnd, linkPlace: filterListLink }))
                }}

              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px'
            }}
          >
            <Grid item md={4}> Link Place <span style={{ color: '#E72A01' }}>*</span></Grid>
            <Grid item md={8}>
              <MultiSelectDropDown
                {...linkPlaceProps()}
                onSelect={(val) => {
                  setLinkPlaceData(prev => ({ ...prev, linkPlace: val }));
                  let filterListStart = placeList?.filter((city) => city.CityID !== val[0]?.CityID)
                  let filterListEnd = placeList?.filter((city) => city.CityID !== val[0]?.CityID)
                  setFilterOpt((prev) => ({ ...prev, startPlace: filterListStart, endPlace: filterListEnd }))
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px'
            }}
          >
            <Grid item md={4}> End Place <span style={{ color: '#E72A01' }}>*</span></Grid>
            <Grid item md={8}>
              <MultiSelectDropDown
                {...endPlaceProps()}
                onSelect={(val) => {
                  setLinkPlaceData(prev => ({ ...prev, endPlace: val }));
                  let filterListLink = placeList?.filter((city) => city.CityID !== val[0]?.CityID)
                  let filterListstart = placeList?.filter((city) => city.CityID !== val[0]?.CityID)
                  setFilterOpt((prev) => ({ ...prev, startPlace: filterListstart, linkPlace: filterListLink }))
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px'
            }}
          >
            <Grid item md={4}>Effective From Date <span style={{ color: '#E72A01' }}>*</span></Grid>
            <Grid item md={8}>
              <CustomDatePicker disabled={isView} selectedDate={linkPlaceData?.fromDate} minDate={linkPlaceData?.fromDate}
                onChange={(val) => {
                  if ((new Date(val) < new Date(linkPlaceData.toDate)) || (linkPlaceData?.toDate === null || linkPlaceData?.toDate === '')) {
                    setLinkPlaceData(prev => ({ ...prev, fromDate: formatDate(val) }))
                  } else {
                    setLinkPlaceData(prev => ({ ...prev, fromDate: formatDate(val), toDate: formatDate(val) }))
                  }
                }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px'
            }}
          >
            <Grid item md={4}>Effective To Date </Grid>
            <Grid item md={8}>
              <CustomDatePicker disabled={isView} selectedDate={linkPlaceData?.toDate} minDate={linkPlaceData?.fromDate} onChange={(val) => { setLinkPlaceData((prev) => ({ ...prev, toDate: formatDate(val) })) }} />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px'
            }}
          >
            <Grid item md={4}>Status </Grid>
            <Grid item md={8}>
              <MultiSelectDropDown
                {...statusProps()}
                onSelect={(val) => { setLinkPlaceData(prev => ({ ...prev, status: val })) }}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{
              paddingRight: '30px',
              gap: '10px',
              flexWrap: 'nowrap',
              paddingBottom: '40px',
              justifyContent: "end"
            }}
          >
            <Grid item md={isView ? 10.5 : 7.5}></Grid>
            {!isView ? isEdit ?
              <Grid item md={1.5}>
                <Button id='lvfUpdateBtn' variant="contained" size="medium"
                  className={`btn-orange`}
                  onClick={() => handleSave()}
                  onKeyDown={(e) => navigation3(e, "lvfResetBtn", "leviesFor", () => handleSave())}
                >
                  UPDATE
                </Button>
              </Grid> :
              <Grid item md={1.5}>
                <Button
                  id='lvfSaveBtn'
                  variant="contained"
                  size="medium"
                  className="btn-orange"
                  onClick={() => handleSave()}
                  onKeyDown={(e) => navigation3(e, "lvfResetBtn", "leviesFor", () => handleSave())}
                >
                  Save
                </Button>
              </Grid>
              : null
            }
            {!isView &&
              <Grid item md={1.5} >
                <Button
                  id='lvfResetBtn'
                  variant="outlined"
                  size="medium"
                  className="btn-orange-outline"
                  onClick={() => handleReset()}
                  onKeyDown={(e) => navigation3(e, "lvfBackBtn", !isView && isEdit ? 'lvfUpdateBtn' : 'lvfSaveBtn', () => handleReset())}
                >
                  RESET
                </Button>
              </Grid>
            }
            <Grid item md={1.5}>
              <Button
                id='lvfBackBtn'
                variant="outlined"
                size="medium"
                className="btn-orange-outline"
                onClick={() => {
                  handleBack(false)
                }}
                onKeyDown={(e) => navigation3(e, "lvfCorpCode", 'lvfResetBtn', () => handleBack(false))}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {showAlert?.open && <Alert msg={showAlert?.msg} alertType={'error'} close={handleAlertClose} buttonText="OK" />}
      <SuccessfulModal open={successModal} width={"300px"} dialogConfirmationMessage={<SuccessfulMessage message={msg} />} onClose={() => {
        setSuccessModal(false)
      }} backgroundColor="#E0EFD8" />
    </>
  )
}

export default LinkPlaceConfigFilters
